<template>
  <div id="SearchOrder">
    <div class="header">
      <h2>SEARCH ORDER<span>訂單查詢</span></h2>
    </div>

    <div class="content">
      <p v-if="search_error != ''" class="info" v-html="search_error"></p>
      <form>
        <div class="form_group">
          <p>姓名<span :class="GetError('name')">請輸入姓名</span></p>
          <input v-model="form_data.name" type="text" name="name" />
        </div>
        <div class="form_group">
          <p>電話<span :class="GetError('phone')">請輸入電話</span></p>
          <input v-model="form_data.phone" type="text" name="phone" />
        </div>
        <div class="form_group">
          <p>電子信箱<span :class="GetError('email')">請輸入電子信箱</span></p>
          <input v-model="form_data.email" type="text" name="email" />
        </div>
        <div class="form_group">
          <p>
            訂單號碼<span :class="GetError('order_id')">請輸入訂單號碼</span>
          </p>
          <input v-model="form_data.order_id" type="text" name="order_id" />
        </div>
      </form>
      <div class="footer">
        <button @click="FormValidate" class="back_button">
          送出查詢<svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="long-arrow-alt-right"
            class="svg-inline--fa fa-long-arrow-alt-right fa-w-14"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "SearchOrder",
  data() {
    return {
      errors: [],
      form_data: {
        name: "",
        email: "",
        phone: "",
        order_id: "",
      },
      search_error: "",
    };
  },
  methods: {
    FormValidate() {
      this.errors = [];
      if (this.form_data.order_id.length <= 0) {
        this.errors.push("order_id");
      }
      if (this.form_data.name.length <= 0) {
        this.errors.push("name");
      }
      if (this.form_data.email.length <= 0) {
        this.errors.push("email");
      } else if (!this.validEmail(this.form_data.email)) {
        this.errors.push("email");
      }
      if (this.form_data.phone.length < 7) {
        this.errors.push("phone");
      }
      if (this.errors.length <= 0) {
        this.GetOrder();
      }
    },
    GetError(key) {
      let error = this.errors.filter((item) => item == key);
      return error.length > 0 ? "error" : "";
    },
    async GetOrder() {
      let data = {
        name: this.form_data.name,
        phone: this.form_data.phone,
        email: this.form_data.email,
        comment: this.form_data.comment,
        order_id: this.form_data.order_id,
      };

      let result = await this.SendPostData(
        process.env.VUE_APP_BASE_API + "orders/get_order.php",
        qs.stringify(data)
      );
      if (result != "error") {
        this.search_error = "";
        if (result.msg != "") {
          this.search_error = "查無訂單，請確認輸入的資料是否正確!";
        } else {
          this.$cookie.set("order_data", JSON.stringify(data));
          this.$router.push("/order_create");
        }
      }
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
  metaInfo() {
    return {
      title: "訂單搜尋｜銳仕技研｜Rerace Performance",
      meta: [
        {
          property: "og:description",
          content: "有任何訂單相關的問題歡迎來訊來電與我們聯絡",
          vmid: "og:description",
        },
        {
          property: "twitter:description",
          content: "有任何訂單相關的問題歡迎來訊來電與我們聯絡",
          vmid: "twitter:description",
        },
        {
          property: "description",
          content: "有任何訂單相關的問題歡迎來訊來電與我們聯絡",
          vmid: "description",
        },
        {
          property: "og:image",
          content: "https://rerace.yongxin-design.com/img/share/index.jpg",
          vmid: "og:image",
        },
        {
          property: "apple-mobile-web-app-title",
          content: "訂單搜尋｜銳仕技研｜Rerace Performance",
          vmid: "apple-mobile-web-app-title",
        },
        {
          property: "application-name",
          content: "訂單搜尋｜銳仕技研｜Rerace Performance",
          vmid: "application-name",
        },
        {
          property: "og:site_name",
          content: "訂單搜尋｜銳仕技研｜Rerace Performance",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:locale",
          content: "zh_tw",
          vmid: "og:locale",
        },
      ],
    };
  },
};
</script>
